export const ports = {
  reniecApi: process.env.REACT_APP_TOKEN_RENIEC,
}